export const FIELDS_GREENSPOTS = [
  { value: "all", label: "all" },
  { value: "land restoration", label: "land restoration" },
  { value: "water generation", label: "water generation" },
  { value: "water purification", label: "water purification" },
  { value: "energy", label: "energy" },
  { value: "waste", label: "waste" },
  { value: "reforestation", label: "reforestation" },
  { value: "biodiversity", label: "biodiversity" },
  { value: "climate", label: "climate" },
  { value: "urban", label: "urban" },
  { value: "coral reefs", label: "coral reefs" },
];
